import ColumnMeta from './ColumnMeta.js';
import CrsMeta from './CrsMeta.js';
import { Header } from './flat-geobuf/header.js';
export default class HeaderMeta {
    constructor(geometryType, columns, envelope, featuresCount, indexNodeSize, crs, title, description, metadata) {
        this.geometryType = geometryType;
        this.columns = columns;
        this.envelope = envelope;
        this.featuresCount = featuresCount;
        this.indexNodeSize = indexNodeSize;
        this.crs = crs;
        this.title = title;
        this.description = description;
        this.metadata = metadata;
    }
    static fromByteBuffer(bb) {
        const header = Header.getRootAsHeader(bb);
        const featuresCount = header.featuresCount();
        const indexNodeSize = header.indexNodeSize();
        const columns = [];
        for (let j = 0; j < header.columnsLength(); j++) {
            const column = header.columns(j);
            if (!column)
                throw new Error('Column unexpectedly missing');
            if (!column.name())
                throw new Error('Column name unexpectedly missing');
            columns.push(new ColumnMeta(column.name(), column.type(), column.title(), column.description(), column.width(), column.precision(), column.scale(), column.nullable(), column.unique(), column.primaryKey()));
        }
        const crs = header.crs();
        const crsMeta = crs
            ? new CrsMeta(crs.org(), crs.code(), crs.name(), crs.description(), crs.wkt(), crs.codeString())
            : null;
        const headerMeta = new HeaderMeta(header.geometryType(), columns, null, Number(featuresCount), indexNodeSize, crsMeta, header.title(), header.description(), header.metadata());
        return headerMeta;
    }
}
//# sourceMappingURL=HeaderMeta.js.map